export async function fetchWithRetry(
  url: string,
  init?: RequestInit,
  retries = 2,
  delayMs = 300
): Promise<Response> {
  for (let attempt = 0; ; attempt++) {
    let res: Response
    try {
      res = await fetch(url, init)
    } catch (error) {
      if (attempt >= retries) {
        throw error
      }
      await new Promise((resolve) =>
        setTimeout(resolve, delayMs * (attempt + 1))
      )
      continue
    }

    if (res.ok) {
      return res
    }

    const retryable = res.status === 429 || res.status >= 500
    if (!retryable || attempt >= retries) {
      throw new Error(
        `Admin API request failed with status ${res.status}: ${url}`
      )
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs * (attempt + 1)))
  }
}
